module.exports = __webpack_public_path__ + "img/6.fe1535b6.png";